import { EMeasuringUnit } from "../interface/IUsage";
import { IUsageDetail } from "../interface/IUsageDetail";
import { IPageableResponse } from "@common/Pagination/interface/IPageableResponse";

interface IUsageDetailResponse {
    usageId: number;
    chargeStartDateTime: string;
    usageCategory: string;
    destinationNumber: string;
    destinationCountryCode: string;
    amount: number;
    measuringUnit: EMeasuringUnit;
    quantity: number;
}

export interface IUsageDetailListResponse {
    usage: IPageableResponse<IUsageDetailResponse>;
}

export const getResponseToState = (response: IUsageDetailListResponse): IPageableResponse<IUsageDetail> => ({
    content: response.usage.content.map((usage) => ({
        amount: usage.amount,
        usageId: usage.usageId,
        chargeStartDateTime: usage.chargeStartDateTime,
        destinationCountryCode: usage.destinationCountryCode,
        destinationNumber: usage.destinationNumber,
        usageCategory: usage.usageCategory,
        measuringUnit: usage.measuringUnit,
        quantity: usage.quantity,
    })),
    totalPages: response.usage.totalPages,
});
